<top-banner variant="title" title="Create Work Order"></top-banner>

<div class="main-content work-order-form-page">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>

          <div class="col-md-10">
            <div class="card-body">
              <card-section-header
                title="Work Order Details"
                icon="fas fa-edit">
              </card-section-header>
              <form *ngIf="!saveInProgress" [formGroup]="form" (ngSubmit)="submit()">
                <ng-container *ngIf="!pageLoading; else formSkeleton">
                <div class="row form-row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Select Asset <span class="required-text">(required)</span></label>
                      <p-dropdown
                        class="form-control sl-input"
                        formControlName="asset"
                        [options]="assets"
                        optionLabel="label"
                        placeholder="Select Asset..."
                        [style]="{ width: '100%' }"
                        filter="true"
                        (onChange)="selectedAssetChange($event)"
                      ></p-dropdown>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Minimum Work Party Size <span class="required-text">(required)</span></label>
                      <input type="number" value="1" class="form-control sl-input" formControlName="minPartySize" min="1" max="30" />
                    </div>
                  </div>
                </div>

                <div class="row form-row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Description <span class="required-text">(required)</span></label>
                      <textarea type="text" class="form-control sl-textarea" formControlName="description"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group rams-group">
                      <label>RAMS</label>
                      <div class="rams-control">
                        <div class="rams-upload" (click)="ramsInput.click()">
                          <span class="rams-placeholder" *ngIf="!selectedDocuments.length">Choose RAMS...</span>
                          <span class="rams-placeholder" *ngIf="selectedDocuments.length">{{ selectedDocuments.length }} file(s) selected</span>
                          <i class="pi pi-upload"></i>
                        </div>
                        <input
                          #ramsInput
                          type="file"
                          class="rams-file-input"
                          name="workOrderRams"
                          id="workOrderRams"
                          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
                          (change)="onFileChange($event)"
                          multiple
                        />
                        <button type="button" class="btn btn-success btn-round rams-add-btn" (click)="ramsInput.click()">Add</button>
                      </div>
                      <ul class="rams-list" *ngIf="selectedDocuments.length">
                        <li *ngFor="let file of selectedDocuments; let i = index">
                          {{ file.name }}
                          <button type="button" class="btn btn-primary btn-link text-left link-underline" (click)="viewSelectedDocument(file)">
                            <i class="fas fa-search"></i>
                            View
                          </button>
                          <button type="button" class="btn btn-link btn-danger link-underline" (click)="removeSelectedDocument(i)">
                            <i class="fas fa-close"></i>
                            Remove
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="row form-row">
                  <div class="col-md-6" *ngIf="allowCompulsoryCheckOnSiteForm">
                    <div class="form-group">
                      <label>Select Compulsory Check-On Site Form</label>
                      <p-dropdown class="form-control sl-input" formControlName="checkOnSiteForm" [options]="siteFormsOptions"
                        placeholder="Select site form..." required="false" [style]="{ width: '100%' }" filter="true">
                      </p-dropdown>
                    </div>
                  </div>

                  <div class="col-md-6" *ngIf="allowCompulsoryCheckOffSiteForm">
                    <div class="form-group">
                      <label>Select Compulsory Check-Off Site Form</label>
                      <p-dropdown class="form-control sl-input" formControlName="checkOffSiteForm" [options]="siteFormsOptions"
                        placeholder="Select site form..." required="false" [style]="{ width: '100%' }" filter="true">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="allowWorkOrderScheduling">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Scheduled Start Time</label>
                      <p-calendar class="form-control sl-input" formControlName="scheduledStartTime" dateFormat="dd/mm/yy" [showTime]="true" [hideOnDateTimeSelect]="false" [minDate]="minDate" panelStyleClass="popupAboveDate"></p-calendar>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Scheduled End Time</label>
                      <p-calendar class="form-control sl-input" formControlName="scheduledEndTime" dateFormat="dd/mm/yy" [showTime]="true" [hideOnDateTimeSelect]="false" [minDate]="minDate" panelStyleClass="popupAboveDate"></p-calendar>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="allowAssetScheduling && !exemptFromAssetScheduling">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>Make Work Order exempt from asset availability schedule</label>
                      <p-checkbox class="form-control" formControlName="exemptFromAssetScheduling" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="row form-row text-center" *ngIf="allowAssetScheduling && exemptFromAssetScheduling">
                  <div class="col-md-12">
                    <div class="alert alert-secondary" role="alert">Asset exempt from schedule</div>
                  </div>
                </div>
                <div *ngIf="validationErrors.length" class="validation-box text-danger">
                  <strong>Please fix the following validation problems to continue:</strong>
                  <div *ngFor="let validationError of validationErrors">- {{ validationError.message }}</div>
                  <br />
                </div>
                </ng-container>
                <ng-template #formSkeleton>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field variant="textarea"></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </form>
              <div *ngIf="saveInProgress" style="text-align: center">
                <p-progressSpinner></p-progressSpinner>
              </div>
              <div *ngIf="!saveInProgress" class="work-order-form-actions">
                <button type="button" (click)="submit()" [disabled]="!form.valid || saveInProgress" class="btn btn-success btn-round work-order-submit">Create Work Order</button>
                <button type="button" (click)="navigateBackToList()" class="btn btn-link btn-link-cancel">
                  <i class="fas fa-times"></i>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
